import { render, staticRenderFns } from "./dialog-passwordexpired.vue?vue&type=template&id=5e6a0c97&"
import script from "./dialog-passwordexpired.vue?vue&type=script&lang=js&"
export * from "./dialog-passwordexpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports